<template>
  <div>
    <template v-if="getStartedUrl">
      <c-card class="pt-5 pb-5 add-first-site">
        <c-card-body>
          <c-container>
            <c-row>
              <c-col cols="12" md="6">
                <mac-plus
                  v-if="getStartedScreenshotUrl"
                  :screenshot-url="getStartedScreenshotUrl"
                  classes="float-right"
                />
<!--                <modern-monitor-->
<!--                    v-if="getStartedScreenshotUrl"-->
<!--                    :screenshot-url="getStartedScreenshotUrl"-->
<!--                    classes="float-right"/>-->
              </c-col>
              <c-col cols="12" md="6">
                <c-row>
                  <c-col cols="12" md="3">
                    <img src="/img/logos/koala-large.svg" style="width: 100%" />
                  </c-col>
                  <c-col cols="12" md="9">
                    <h1 class="h1 font-weight-normal">Hey Boss</h1>
                    <h2 class="h3">YOU'RE ALMOST THERE.</h2>
                  </c-col>
                </c-row>
                <div style="max-width: 400px" class="ml-4 mt-5">
                  <add-a-new-site :get-started="true" :new-site-url="getStartedUrl" @screenshotUrl="setScreenshot" />
                </div>
              </c-col>
            </c-row>
          </c-container>
        </c-card-body>
      </c-card>
    </template>
    <template v-else>
      <add-new-site default-message="Let's add your new site... Only 2 steps!" />
    </template>
  </div>
</template>

<script>
import _ from 'lodash';
import AddANewSite from '../site/add-new-site';
import AddNewSite from '@/views/components/dashboard/AddNewSite';
import MacPlus from '@/views/components/plugin-install/MacPlus';
import ModernMonitor from '@/views/components/plugin-install/ModernMonitor';

export default {
  name: 'AddFirstSite',
  components: {
    AddANewSite,
    AddNewSite,
    MacPlus,
    ModernMonitor,
  },
  props: {},
  data() {
    return {
      screenshotUrl: null,
    };
  },
  computed: {
    getStartedUrl() {
      return _.get(this.$store.state, 'app.authenticatedUser.organisation.getStarted.url');
    },
    getStartedScreenshotUrl() {
      return _.get(this.$store.state, 'app.authenticatedUser.organisation.getStarted.screenshotUrl');
    },
  },
  methods: {
    setScreenshot(url) {
      this.screenshotUrl = url;
    },
  },
};
</script>
